import angular from 'angular';
import faceComponent from './face.component';

import faceHeaderModule from './face-header/face-header';
import indexModule from './index/index';
import authorsModule from './authors/authors';
import mediasModule from './medias/medias';
import consumersModule from './consumers/consumers';
import pluginModule from './plugin/plugin';
import newsCenterModule from './news-center/news-center';
import dataSmartModule from './data-smart/data-smart'
import pricingModule from './pricing/pricing'
import partners from './partners/partners'
import solutions from './solutions/solutions'
import cooperation from './cooperation/cooperation'
import application from './application/application'


let childModules = [
    indexModule,
    faceHeaderModule,
    authorsModule,
    mediasModule,
    consumersModule,
    pluginModule,
    newsCenterModule,
    dataSmartModule,
    pricingModule,
    partners,
    solutions,
    cooperation,
    application
];

let states = [
    {
        name: 'face',
        abstract: true,
        component: 'face'
    }
];

let childModuleNames = [];

childModules.forEach((m) => {
    childModuleNames.push(m.name);

    m.states.forEach((s) => {

        s.name = 'face.' + s.name;

        states.push(s);
    });
});

let faceModule = angular.module('face', childModuleNames)

    .component('face', faceComponent)

    .name;

export default {name: faceModule, states: states};





// WEBPACK FOOTER //
// ./src/app/components/face/face.js